module.exports = __webpack_public_path__ + "static/media/028-myanmar.352cb0c5.svg";